import React from "react";
import { useNavigate } from "react-router-dom";
import Management from "components/general/Management";
import { useAuth } from "AuthContext";
import toastr from "toastr";

const UniversityCourses = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const layout = [
    [{ label: "Mã môn học", name: "code", type: "input", rules: [{ required: true }] }],
    [{ label: "Tên môn học", name: "name", type: "input", rules: [{ required: true }] }],
    [{ label: "Mô tả", name: "description", type: "textarea", rules: [{ required: true }] }],
    [{ label: "Ảnh môn học", name: "logo", type: "upload" }],
    [{ label: "Tín chỉ", name: "credit", type: "number", rules: [{ required: true, type: "inputNumber", min: 0 }] }],
  ];

  return (
    <div>
      <h2>Quản Lý Môn Học</h2>
      <Management
        layout={layout}
        apiPath="/courses/"
        itemName="môn học"
        listMode="card"
        useFrontendPagination={false}
        disableSearch={false}
        onCardClick={(item) => navigate(`/university-courses/${item.id}`)}
        excelImportExportOptions={user.role === 2 ? null : {
          apiPath: "/courses/",
          itemName: "môn học",
          exportFields: ["name", "description", "credit"],
          expectedCsvType: "courses",
        }}
        defaultLogo={process.env.PUBLIC_URL + '/img/standard-logo.png'}
        customActions={user.role === 2 ? ()=>{} : null}
        onSubmitError={(error) => {
          if (
            error?.response?.status === 400 && error?.response?.data?.non_field_errors
            && error?.response?.data?.non_field_errors[0] === "The fields university, code must make a unique set."
          ) {
            toastr.error("Mã môn học đã tồn tại");
          }
        }}
        noChange={user.role === 2}
        tranformData={(value) => ({
          ...value,
          formatName: `${value.code} - ${value.name}`,
          formatDescription: `<b>Tín chỉ:</b> ${value.credit}<br/>${value.description}`
        })}
      />
    </div>
  );
};

export default UniversityCourses;
